// Services
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"

// Mixins
// import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { comingSoonMixins } from "@/app/mixins/modules/coming-soon-mixins"

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/constants.js';

const DOG_GENDER = {
    DAM: "Dam",
    SIRE: "Sire",
}

export default {
	name: 'BreederMatingDetailsComponent',
	components: {},
	directive: {},
	filters: {},
	mixins: [
		toastMessageMixins,
		dateMixins,
		comingSoonMixins,
	],
	props: {},
	data() {
		return {
			isAPILoading: false,
			isAPISubmitLoading: false,

			matingId: "",
			littersCount: 0,

			matingNotes: "",
			matingNotesHistory: [],

			damList: [],
			selectedDam: "",
			isDamImageLoading: false,

			sireList: [],
			selectedSire: "",
			isSireImageLoading: false,

			initialValues: {},

			breederSysId: null
		}
	},
	computed: {},
	watch: {},
	async created() {
		this.breederSysId = this.$route.params.breederSysId;
		this.matingId = this.$route.params.id;
		this.damList = await this.getBreederDamAndSireListByGender(DOG_GENDER.DAM);
		this.sireList = await this.getBreederDamAndSireListByGender(DOG_GENDER.SIRE);
		await this.getDamAndSireMatingDetails(this.matingId);
		
	},
	methods: {
		async onUpdateDetails() {
			try {
				if (!this.selectedDam && !this.selectedSire) {
					await this.$swal({
						text: "Please select either Dam or Sire.",
						imageHeight: "150px",
						imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
						imageAlt: "Sad Dog",
						confirmButtonText: 'Got it',
						showCloseButton: true,
					})

					return;
				};

				this.isAPISubmitLoading = true;

				const matingDetails = {
					damId: this.selectedDam ? this.selectedDam.id : null,
					sireId: this.selectedSire ? this.selectedSire.id : null,
					note: this.matingNotes
				};

				const response = await breedingManagementService.updateDamAndSireMatingDetails(this.breederSysId, this.matingId, matingDetails);

				const { SUCCESS_UPDATE_MATING, ERROR_UPDATE_MATING } = this.toastMessages.mating();

				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_MATING);
					this.getDamAndSireMatingDetails(this.matingId);
				} else {
					this.showAPIErrorToast(ERROR_UPDATE_MATING, response);
				}

			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPISubmitLoading = false;
			}
		},
		async getBreederDamAndSireListByGender(gender) {
			if (!gender) {
				return;
			}

			try {
				this.isAPILoading = true;
				const damSireListResponse = await breedingManagementService.getBreederDamAndSireListByGender(this.breederSysId, gender);

				if (damSireListResponse.status === STATUS_CODES.SUCCESS) {
					const { data: listData } = damSireListResponse;

					// customLabel to be used in the v-select "label" for searching by breedName and dogName combined
					const formattedData = listData.map(data => {
						const { breedName, dogName } = data;

						if (breedName && dogName) {
							return { ...data, customLabel: `${breedName} - ${dogName}` };
						} else {
							return { ...data, customLabel: `${breedName}` };
						}

					})

					return formattedData;
				} else {
					const { ERROR_GET_DAM_SIRE_LIST } = this.toastMessages.mating();
					this.showAPIErrorToast(ERROR_GET_DAM_SIRE_LIST, damSireListResponse);
				}
			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPILoading = false;
			}
		},
		async getDamAndSireMatingDetails(matingId) {
			if (!matingId) {
				return;
			}

			try {
				this.isAPILoading = true;
				const matingDetailsResponse = await breedingManagementService.getAdminDamAndSireMatingDetails(this.breederSysId, matingId);

				if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
					const { data: matingDetails } = matingDetailsResponse;

					const { damDetails, sireDetails, matingNotesHistory, littersCount } = matingDetails;

					this.littersCount = littersCount;

					if (damDetails) {
						const { breedName, dogName, birthdate } = damDetails;

						this.selectedDam = {
							...damDetails,
							birthdate: this.formatDate(birthdate),
							customLabel: `${breedName} - ${dogName}`
						};

						this.initialValues.selectedDam = this.selectedDam;
					} else {
						this.initialValues.selectedDam = null;

					}

					if (sireDetails) {
						const { breedName, dogName, birthdate } = sireDetails;

						this.selectedSire = {
							...sireDetails,
							birthdate: this.formatDate(birthdate),
							customLabel: `${breedName} - ${dogName}`
						};

						this.initialValues.selectedSire = this.selectedSire;
					} else {
						this.initialValues.selectedSire = null;
					}

					if (matingNotesHistory && matingNotesHistory.length > 0) {
						this.matingNotesHistory = matingNotesHistory.filter(noteObj => noteObj.note !== "");
						this.matingNotes = matingNotesHistory[0].note;

						this.initialValues.matingNotes = this.matingNotes;
					} else {
						this.initialValues.matingNotes = "";
					}

				} else {
					const { ERROR_GET_MATING_DETAILS } = this.toastMessages.mating();
					this.showAPIErrorToast(ERROR_GET_MATING_DETAILS, matingDetailsResponse);
				}
			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPILoading = false;
			}
		},
		onDamSelect(selectedItem) {
			if (!selectedItem) {
				return;
			}

			if (selectedItem.imageUrl) {
				this.isDamImageLoading = true;
			} else {
				this.isDamImageLoading = false;
			}

			this.selectedDam = { ...selectedItem, birthdate: this.formatDateTime(new Date(selectedItem.birthdate), "dd-MMM-yyyy") };
		},
		onSireSelect(selectedItem) {
			if (!selectedItem) {
				return;
			}

			if (selectedItem.imageUrl) {
				this.isSireImageLoading = true;
			} else {
				this.isSireImageLoading = false;
			}

			this.selectedSire = { ...selectedItem, birthdate: this.formatDateTime(new Date(selectedItem.birthdate), "dd-MMM-yyyy") };
		},
		handleLoadingImage(gender) {
			if (DOG_GENDER.DAM === gender) {
				this.isDamImageLoading = false;
			}

			if (DOG_GENDER.SIRE === gender) {
				this.isSireImageLoading = false;
			}
		},
		redirectToGestation() {
			if (!this.initialValues.selectedDam && !this.initialValues.selectedDam.id) {
				return;
			}

			this.$router.push(`/breeder-management/${this.breederSysId}/${this.initialValues.selectedDam.id}/gestation-period?from=mating-details`);
		},
		redirectToLitterList() {
			if (!this.matingId) {
				return;
			}
			this.$router.push(`/breeder-management/litter-puppy-list/${this.breederSysId}/${this.matingId}?from=mating-details`)
		},
	},
	// third party libraries
}